import ServerConfig from '@core/models/country/ServerConfig';
import { instanceGuard } from '@core/utils/services';
import SingletonError from '../common/errors/SingletonError';
import Singleton from '../common/Singleton';

class OfferHostProvider {
    private static instance?: OfferHostProvider;

    private offerHostServers: string[];
    private currentOfferHost: string;

    private offerHostServersSocket: string[];
    private currentOfferHostSocket: string;

    private constructor(config: ServerConfig) {
        if (OfferHostProvider.instance) {
            throw new SingletonError(this.constructor.name);
        }
        const { socketIoAllValues, hostServerAllValues } = config.offer;
        this.offerHostServers = hostServerAllValues;
        this.offerHostServersSocket = socketIoAllValues;

        this.setRandomOfferHost();
    }

    public static getInstance(): OfferHostProvider {
        return instanceGuard(OfferHostProvider.instance)!;
    }

    public getCurrentOfferHost(): string {
        return `${this.currentOfferHost}/`;
    }

    public getCurrentOfferHostSocket(): string {
        // returnSiteParams are returning url with / on the end, but on production we have to add it manually
        if (this.currentOfferHostSocket.slice(-1) === '/') {
            return `${this.currentOfferHostSocket}`;
        }
        return `${this.currentOfferHostSocket}/`;
    }

    /**
     * Returns timeout value in seconds which is generated randomly from a range of numbers
     */
    public retryTimeout(): number {
        return this.getRandomInt(30, 10) * 1000;
    }

    public setRandomOfferHost(): void {
        const max = this.offerHostServers.length - 1;
        this.currentOfferHost = this.offerHostServers[this.getRandomInt(max)];

        const maxSocketHosts = this.offerHostServersSocket.length - 1;
        this.currentOfferHostSocket = this.offerHostServersSocket[this.getRandomInt(maxSocketHosts)];
    }

    /**
     *  Generates random number with the set max margin (Should be moved to Math utils)
     * @param max top number that will be generated by the function
     * @param min (default: 0) optional minimum number that will be generated by the function
     */
    private getRandomInt(max: number, min: number = 0): number {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    public static createInstance(config: ServerConfig) {
        if (!OfferHostProvider.instance) {
            OfferHostProvider.instance = new OfferHostProvider(config);
        }
        return OfferHostProvider.instance;
    }

    public static clearInstance() {
        if (process.env.NODE_ENV !== 'test') {
            throw new Error('For use in tests only');
        }
        delete OfferHostProvider.instance;
    }
}

export default OfferHostProvider as Singleton<OfferHostProvider>;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/offer/OfferHostProvider.ts